import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SettingsComponent implements OnInit {

  page = {
    pageNumber: 0,
    offset: 0,
    pageSize: 100,
    totalPages: 0
  };
  public rows = [];
  public filterRows = [];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  public columns = [
    { name: " Name", prop: "name" },
    { name: "Email", prop: "email" },
    { name: "Actions", prop: "actions" },
  ];
  setting_model={
    key: '',
    value: '',
    data_type: '',
    notes: '',
    admin_notes: ''
  }
  row_id:any
  @ViewChild('name') inputName;
  searchVal=''
  dataType_list=[
    {name:'Text',_id:'text'},
    {name:'Number',_id:'number'},
    {name:'Date',_id:'date'},
    {name:'Rich Text',_id:'richtext'}
  ]
  selected_datatype=''
  row_data:any
  setting_data:any
  isupdate_value : boolean 
  guideline_data:any
  
  constructor(public apiService: ApiService,public toastr: ToastrService,
              private modalService: NgbModal,private spinner: NgxSpinnerService,
              ) { }

  ngOnInit(): void {
    this.getSettingList()
  }
  getSettingList(){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getAllSetting(this.page.pageNumber+1,this.limitRef).subscribe((res:any)=>{
      this.spinner.hide()
      this.rows = res?.items
      this.page.totalPages = res?.total
      let key_data = res?.items.filter((item) => item.key == 'Admin Settings') 
      this.guideline_data = key_data[0]?._id
    })
  }
  openModal(content,id,data){
    if(id && data ){
      this.row_id = id
      this.setting_model.key = data?.key
      this.setting_model.value = data?.value
      this.selected_datatype = data?.data_type
      this.setting_model.data_type =   this.selected_datatype
      this.setting_model.notes = data?.notes
      this.setting_model.admin_notes = data?.admin_notes
    }
    if(!this.row_id){
      this.selected_datatype='text'
    }
    const modalOptions: NgbModalOptions = {
      size: 'lg',
      backdrop: 'static', 
      centered: true 
    };
    const modalRef = this.modalService.open(content,modalOptions);
    modalRef.result.then((result) => {
      this.row_id = ''
      this.setting_model.key = ''
      this.setting_model.value = ''
      this.setting_model.data_type = ''
      this.setting_model.notes = ''
      this.setting_model.admin_notes = ''
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      this.row_id = ''
      this.setting_model.key = ''
      this.setting_model.value = ''
      this.setting_model.data_type = ''
      this.setting_model.notes = ''
      this.setting_model.admin_notes = ''
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  submit(){
    if(!this.row_id){
      this.setting_model.data_type = this.selected_datatype

      this.apiService.addSetting(this.setting_model).subscribe((res:any)=>{
        if(res?.statusCode === 200){
          this.toastr.success(res?.message)
          this.modalService.dismissAll()
          this.getSettingList()
        }
        else this.toastr.error(res?.error)
      })
    }
    if(this.row_id){
      this.setting_model.data_type = this.selected_datatype
      if( this.setting_model.admin_notes ==''){
        this.setting_model.admin_notes = ''
      }
      this.apiService.updateSetting(this.row_id,this.setting_model).subscribe((res:any)=>{
        if(res?.statusCode === 200){
          this.toastr.success(res?.message)
          this.modalService.dismissAll()
          this.getSettingList()
        }
        else this.toastr.error(res?.error)
      })
    }
    
  }

  delete(id) {
    this.apiService.deleteSetting(id).subscribe((res: any) => {
      if(res.statusCode === 200){
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
        this.getSettingList()
      }
      else {
        swal.fire({
          icon: "error",
          title: 'Error!',
          text: `${res.error}`,
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    })
  }

   // ================== Delete Alert ========================
   confirmDelete(id: any) {
    this.row_id = id
    swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to delete this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: 'Yes, delete it!',
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
    }).then((result) => {
      if (result.value) {
        this.delete( this.row_id)

      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe ',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  filter(val){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.searchSettings(val).subscribe((res:any)=>{
      this.spinner.hide()
      this.rows = res?.data?.items
      this.page.totalPages = res?.data?.totalCount
    })
  }
  resetFilter(){
    this.inputName.nativeElement.value = null;
    this.getSettingList()
  }
  getDatatypeId(event){
    this.selected_datatype
  }
  setFocus(event) {
    this.setting_model.value = event.html
    if(this.setting_data){
      this.setting_data.value = event.html
    }
  }
  openValue(content,data){
    this.row_id = data._id
    this.setting_data = data
    const modalOptions: NgbModalOptions = {
      size: 'lg' 
    };
    const modalRef = this.modalService.open(content,modalOptions);
    modalRef.result.then((result) => {
      this.setting_data = ''
      this.row_id = ''
      this.isupdate_value = false
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      this.setting_data = ''
      this.row_id = ''
      this.isupdate_value = false
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  isEdit(){
    this.isupdate_value = !this.isupdate_value
  }
  updateValue(){
      let body= {
        value : this.setting_data.value
      }
    this.apiService.updateSetting(this.row_id,body).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.toastr.success(res?.message)
        this.modalService.dismissAll()
        this.getSettingList()
      }
      else this.toastr.error(res?.error)
    })
  }
  stripHtmlTags(html) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
}
openDynamicModal(key_id:string) {
  const modalOptions: NgbModalOptions = {
    size: 'lg', // 'sm', 'lg', or 'xl'
    backdrop: 'static',
  };
  const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
  modalRef.componentInstance.key_id = key_id;
}
 
}
